var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Page",
    [
      _c("template", { slot: "header-breadcrumb-left" }, [
        _c(
          "div",
          { staticClass: "Breadcrumb m-top-5" },
          [
            _c(
              "router-link",
              {
                staticClass: "c-light",
                attrs: {
                  id: "approved-order-breadcrumb",
                  to: { name: "Orders" },
                },
              },
              [_vm._v(_vm._s(_vm.$t("Orders.breadcrumb_ApprovedOrders")))]
            ),
            _c("span", [_vm._v(_vm._s(">"))]),
            _c(
              "div",
              { staticClass: "relative-pairs-tooltip" },
              [
                _c(
                  "a",
                  {
                    staticClass: "isSelected",
                    attrs: {
                      href: "",
                      id: "approved-order-detail-breadcrumb-active-spot-list",
                    },
                  },
                  [_vm._v(_vm._s(_vm.headerInfo?.orderNumber))]
                ),
                _c("PairsTooltip", {
                  attrs: {
                    list: _vm.breadCrumbHoverInfo,
                    itemKey: "key",
                    itemValue: "value",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "template",
        { slot: "header-left-dropdown" },
        [
          _c("PageTabButtons", {
            staticClass: "m-left-10",
            attrs: {
              selectedList: _vm.requestHeaderLinks,
              translationGroup: "Request",
              matchedRoute: "Orders",
            },
          }),
        ],
        1
      ),
      _c(
        "template",
        { slot: "header-right-content" },
        [
          _vm.approveOrdersDetail.length
            ? _c(
                "Button",
                {
                  attrs: {
                    id: "btn-approved-order-detail-new",
                    type: "button",
                    primary: "",
                    size: "medium",
                    iconName: "icon-global-add",
                    iconClass: "icon-global-add",
                  },
                  on: { click: _vm.addNewDetail },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("Global.addNewStock")))])]
              )
            : _vm._e(),
        ],
        1
      ),
      _c("template", { slot: "toolbar-left" }),
      _c("template", { slot: "toolbar-right" }),
      _c(
        "template",
        { slot: "content-center" },
        [
          !_vm.hasTabPermission ? _c("NoPermission") : _vm._e(),
          _vm.isFetchingPageData || _vm.isFetchingOrderList
            ? _c("TableLoading", { staticClass: "sticky" })
            : _vm._e(),
          !_vm.approveOrdersDetail.length &&
          !_vm.isFetchingPageData &&
          !_vm.isFetchingOrderList
            ? _c("EmptyState", {
                attrs: {
                  title: _vm.$t("Orders.orders_emptyState_NotFound_Title"),
                  description: _vm.$t(
                    "Orders.orders_emptyState_NotFound_Description"
                  ),
                },
              })
            : _vm._e(),
          _vm.approveOrdersDetail.length
            ? _c("TableView", {
                attrs: {
                  fields: _vm.ordersDetailFields,
                  actions: _vm.hasOrderEdit ? ["edit"] : [""],
                  readOnly: !_vm.hasOrderEdit,
                  data: _vm.approveOrdersDetail,
                  usePortalAction: true,
                },
                on: { delegateOnItemEdit: _vm.editDetailAction },
              })
            : _vm._e(),
          _c("portal", {
            attrs: { to: "detailDescription" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return _c(
                    "div",
                    {},
                    [
                      row.description
                        ? _c(
                            "Button",
                            {
                              staticClass:
                                "show-MiniPopup relative width-max-content btn-info",
                              attrs: {
                                iconName: "icon-global-info",
                                justIcon: true,
                                id: `orders-detail-info-button-${row.rowIndex}`,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "MiniPopup-leftCenter-primary m-top-15 c-dark",
                                },
                                [_c("span", [_vm._v(_vm._s(row.description))])]
                              ),
                            ]
                          )
                        : _c("span", [_vm._v("-")]),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
          _c("router-view", { on: { getList: _vm.getList } }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }